import { DayOfWeek } from '../../../models/common-enum';
export const days = [
    { id: DayOfWeek.Monday, name: 'จันทร์' },
    { id: DayOfWeek.Tuesday, name: 'อังคาร' },
    { id: DayOfWeek.Wednesday, name: 'พุธ' },
    { id: DayOfWeek.Thursday, name: 'พฤหัสบดี' },
    { id: DayOfWeek.Friday, name: 'ศุกร์' },
    { id: DayOfWeek.Saturday, name: 'เสาร์' },
    { id: DayOfWeek.Sunday, name: 'อาทิตย์' }
];